import { FC } from "react";

const ArrowWithdraw: FC = () => {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.09598 4.09682L4.66713 0.667969L1.23828 4.09682"
        stroke="#1E2939"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66797 0.667969V8.66862"
        stroke="#1E2939"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.667969 10.9531H8.66862"
        stroke="#1E2939"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ArrowWithdraw;
